import { Controller } from 'stimulus';

const DATEPICKER_LANG = {
  nl: {
    days: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
    daysShort: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    months: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
  },
};

class Datepicker extends Controller {
  connect() {
    import(/* webpackChunkName: "datepicker" */ '@chenfengyuan/datepicker').then(() => {
      this.lang = DATEPICKER_LANG.nl;

      this.lang.daysMin = this.lang.daysShort;

      this.baseOptions = {
        days: this.lang.days,
        daysShort: this.lang.daysShort,
        daysMin: this.lang.daysMin,
        months: this.lang.months,
        monthsShort: this.lang.monthsShort,
        autoHide: true,
        format: 'dd-mm-yyyy',
        disabledClass: 'disabled js-is-disabled',
      };

      this.createDatepicker();
    });
  }

  createDatepicker() {
    const $datepicker = $(this.element);
    const options = Object.assign({}, this.baseOptions);

    if (typeof $datepicker.data('datepicker-type') !== 'undefined') {
      const type = $datepicker.data('datepicker-type');

      options.startView = type === 'birthday' ? 2 : 0;
    }

    $datepicker.datepicker(options);
  }
}

Datepicker.targets = [
  //
];

export default Datepicker;
